import LegalPage, { H, LEGAL_ENTITY } from './LegalPage';

/** Meta App Review требует публичный Data Deletion URL — это он. */
export default function DataDeletion() {
  return (
    <LegalPage title="Удаление данных" updated="30.10.2026">
      <H>Пользователи AdaMar</H>
      <p>Чтобы удалить аккаунт и связанные данные, напишите с email вашего аккаунта на {LEGAL_ENTITY.email} с темой «Удаление аккаунта». Мы удалим аккаунт, профиль и токены Instagram в течение 30 дней и подтвердим ответным письмом.</p>

      <H>Подключённый Instagram</H>
      <p>Отключить Instagram можно двумя способами: (1) написать нам на {LEGAL_ENTITY.email} — мы удалим токен и связь аккаунта немедленно; (2) удалить AdaMar в настройках Instagram (Настройки → Разрешения сайтов → Приложения) — доступ будет отозван на стороне Instagram, а мы удалим сохранённый токен.</p>

      <H>Публичный каталог</H>
      <p>Если ваш публичный Instagram-аккаунт присутствует в аналитическом каталоге AdaMar и вы хотите его исключить — напишите на {LEGAL_ENTITY.email} со ссылкой на профиль. Удалим из каталога в течение 30 дней.</p>
    </LegalPage>
  );
}
